export default __webpack_public_path__ + "static/media/usc-films-express.8367ba55.jpg";